import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import Navbar from './Navbar';
import Footer from './Footer';
import {
    LuSearch,
    LuChevronDown,
    LuChevronUp,
    LuCircleHelp,
    LuUser,
    LuCreditCard,
    LuSettings
} from 'react-icons/lu';

function FAQ() {
    const { t, lang } = useLanguage();
    const [searchQuery, setSearchQuery] = useState('');
    const [activeCategory, setActiveCategory] = useState('general');
    const [openItems, setOpenItems] = useState({});

    const categories = [
        { id: 'general', label: t('faq.categories.general'), icon: LuCircleHelp },
        { id: 'account', label: t('faq.categories.account'), icon: LuUser },
        { id: 'billing', label: t('faq.categories.billing'), icon: LuCreditCard },
        { id: 'technical', label: t('faq.categories.technical'), icon: LuSettings }
    ];

    const faqData = {
        general: lang === 'tr' ? [
            {
                q: "Getiri Hesaplama nedir?",
                a: "Getiri Hesaplama, yatirim getirisi hesaplama ve finansal planlama araci sunan bir web uygulamasidir. Bilesik faiz hesaplamalari, hedef planlama ve risk analizi gibi ozellikler sunmaktadir."
            },
            {
                q: "Uygulama ucretsiz mi?",
                a: "Evet, temel ozellikler ucretsizdir. Gunluk 5 hesaplama yapabilir, temel grafikleri gorebilir ve yerel gecmis kaydedebilirsiniz. Daha fazla ozellik icin Premium abonelik mevcut."
            },
            {
                q: "Hesaplamalar ne kadar dogru?",
                a: "Hesaplamalar matematiksel formullere dayanmaktadir ve yuksek hassasiyetle yapilmaktadir. Ancak gercek piyasa kosullari farkli olabilir, bu nedenle sonuclar tahmini olarak degerlendirilmelidir."
            },
            {
                q: "Hangi para birimlerini destekliyorsunuz?",
                a: "Hesaplamalar USDT (Tether) bazinda yapilmaktadir. Turk Lirasi karsiligi icin gunluk doviz kuru kullanilmaktadir."
            }
        ] : [
            {
                q: "What is Getiri Hesaplama?",
                a: "Getiri Hesaplama is a web application that provides investment return calculation and financial planning tools. It offers features such as compound interest calculations, goal planning, and risk analysis."
            },
            {
                q: "Is the application free?",
                a: "Yes, basic features are free. You can make 5 calculations per day, view basic charts, and save local history. Premium subscription is available for more features."
            },
            {
                q: "How accurate are the calculations?",
                a: "Calculations are based on mathematical formulas and are performed with high precision. However, real market conditions may differ, so results should be considered as estimates."
            },
            {
                q: "Which currencies do you support?",
                a: "Calculations are made in USDT (Tether) base. Daily exchange rate is used for Turkish Lira equivalent."
            }
        ],
        account: lang === 'tr' ? [
            {
                q: "Nasil hesap olustururum?",
                a: "Kayit Ol sayfasindan email adresiniz ve sifrenizle ucretsiz hesap olusturabilirsiniz. 7 gunluk Premium deneme otomatik olarak baslar."
            },
            {
                q: "Sifremi unuttum, ne yapmaliyim?",
                a: "Giris sayfasindaki 'Sifremi Unuttum' linkine tiklayarak email adresinize sifre sifirlama linki gonderebilirsiniz."
            },
            {
                q: "Hesabimi nasil silerim?",
                a: "Profil > Guvenlik bolumunden hesabinizi silebilirsiniz. Bu islem geri alinamaz ve tum verileriniz kalici olarak silinir."
            },
            {
                q: "Birden fazla cihazda kullanabilir miyim?",
                a: "Evet, hesabinizla istediginiz cihazdan giris yapabilirsiniz. Premium kullanicilar icin bulut senkronizasyonu da mevcuttur."
            }
        ] : [
            {
                q: "How do I create an account?",
                a: "You can create a free account from the Register page with your email address and password. 7-day Premium trial starts automatically."
            },
            {
                q: "I forgot my password, what should I do?",
                a: "You can send a password reset link to your email by clicking the 'Forgot Password' link on the login page."
            },
            {
                q: "How do I delete my account?",
                a: "You can delete your account from Profile > Security section. This action cannot be undone and all your data will be permanently deleted."
            },
            {
                q: "Can I use it on multiple devices?",
                a: "Yes, you can log in from any device with your account. Cloud synchronization is also available for Premium users."
            }
        ],
        billing: lang === 'tr' ? [
            {
                q: "Premium abonelik ne kadar?",
                a: "Premium abonelik aylik 49.99 TL veya yillik 399.99 TL'dir. Yillik abonelikte %33 tasarruf edersiniz."
            },
            {
                q: "Hangi odeme yontemlerini kabul ediyorsunuz?",
                a: "Kredi karti, banka karti ve havale/EFT ile odeme yapabilirsiniz. Kurumsal musteriler icin fatura secenegi de mevcuttur."
            },
            {
                q: "Aboneligimi nasil iptal edebilirim?",
                a: "Profil > Abonelik bolumunden aboneliginizi iptal edebilirsiniz. Iptalden sonra mevcut donem sonuna kadar Premium ozellikler aktif kalir."
            },
            {
                q: "Para iadesi alabilir miyim?",
                a: "Satin alma tarihinden itibaren 14 gun icinde kosulsuz para iadesi yapilmaktadir."
            }
        ] : [
            {
                q: "How much is Premium subscription?",
                a: "Premium subscription is 49.99 TL monthly or 399.99 TL yearly. You save 33% with annual subscription."
            },
            {
                q: "What payment methods do you accept?",
                a: "We accept credit card, debit card, and bank transfer. Invoice option is also available for corporate customers."
            },
            {
                q: "How can I cancel my subscription?",
                a: "You can cancel your subscription from Profile > Subscription section. Premium features remain active until the end of the current period after cancellation."
            },
            {
                q: "Can I get a refund?",
                a: "Unconditional refund is available within 14 days of purchase."
            }
        ],
        technical: lang === 'tr' ? [
            {
                q: "Hangi tarayicilari destekliyorsunuz?",
                a: "Chrome, Firefox, Safari ve Edge'in son surumlerini destekliyoruz. En iyi deneyim icin tarayicinizi guncel tutmanizi oneririz."
            },
            {
                q: "Mobil uygulama var mi?",
                a: "Su an icin mobil uygulama mevcut degildir, ancak web sitemiz mobil uyumludur ve tum cihazlarda sorunsuz calisir."
            },
            {
                q: "Verilerim guvenli mi?",
                a: "Evet, tum veriler SSL ile sifrelenip aktarilir ve veritabaninda sifreli olarak saklanir. Duzenli guvenlik denetimleri yapilmaktadir."
            },
            {
                q: "API erisimi var mi?",
                a: "Premium kullanicilar API erisimi alabilir. Detaylar icin destek ekibimizle iletisime gecin."
            }
        ] : [
            {
                q: "Which browsers do you support?",
                a: "We support the latest versions of Chrome, Firefox, Safari, and Edge. We recommend keeping your browser up to date for the best experience."
            },
            {
                q: "Is there a mobile app?",
                a: "There is currently no mobile app, but our website is mobile-friendly and works seamlessly on all devices."
            },
            {
                q: "Is my data secure?",
                a: "Yes, all data is encrypted with SSL during transmission and stored encrypted in the database. Regular security audits are performed."
            },
            {
                q: "Is there API access?",
                a: "Premium users can get API access. Contact our support team for details."
            }
        ]
    };

    const toggleItem = (category, index) => {
        const key = `${category}-${index}`;
        setOpenItems(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    const filteredFAQ = faqData[activeCategory]?.filter(item =>
        item.q.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.a.toLowerCase().includes(searchQuery.toLowerCase())
    ) || [];

    return (
        <div className="app-container">
            <Navbar />

            <main className="main-content">
                <div className="faq-page">
                    <div className="faq-header">
                        <h1>{t('faq.title')}</h1>
                        <p>{t('faq.subtitle')}</p>

                        <div className="faq-search">
                            <LuSearch className="search-icon" />
                            <input
                                type="text"
                                className="form-input"
                                placeholder={t('faq.search')}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="faq-content">
                        {/* Categories */}
                        <div className="faq-categories">
                            {categories.map((cat) => (
                                <button
                                    key={cat.id}
                                    className={`faq-category ${activeCategory === cat.id ? 'active' : ''}`}
                                    onClick={() => setActiveCategory(cat.id)}
                                >
                                    <cat.icon />
                                    {cat.label}
                                </button>
                            ))}
                        </div>

                        {/* FAQ Items */}
                        <div className="faq-list">
                            {filteredFAQ.length === 0 ? (
                                <div className="faq-empty">
                                    <LuCircleHelp />
                                    <p>{lang === 'tr' ? 'Sonuc bulunamadi' : 'No results found'}</p>
                                </div>
                            ) : (
                                filteredFAQ.map((item, index) => {
                                    const key = `${activeCategory}-${index}`;
                                    const isOpen = openItems[key];
                                    return (
                                        <div
                                            key={index}
                                            className={`faq-item ${isOpen ? 'open' : ''}`}
                                        >
                                            <button
                                                className="faq-question"
                                                onClick={() => toggleItem(activeCategory, index)}
                                            >
                                                <span>{item.q}</span>
                                                {isOpen ? <LuChevronUp /> : <LuChevronDown />}
                                            </button>
                                            {isOpen && (
                                                <div className="faq-answer">
                                                    <p>{item.a}</p>
                                                </div>
                                            )}
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    </div>

                    {/* Contact CTA */}
                    <div className="faq-cta">
                        <h3>{t('faq.contactSupport')}</h3>
                        <Link to="/support" className="btn btn-primary">
                            {t('support.title')}
                        </Link>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default FAQ;
